/* hwlink */
/*--------------------------------------------------------------------------------*/
import { cfg } from '../../config';
import { loading, ready } from '../../page';
import { template } from './template';
const app = document.querySelector<HTMLElement>('#app');
let isREADY: boolean;
let WSSVC: WebSocket;
/*--------------------------------------------------------------------------------*/
export const hwLink = () => {
    if (!app) return;
    // template
    const content = document.createElement('div');
    content.id = 'app-content';
    content.innerHTML = template;
    app.classList.add('full-page');
    app.appendChild(content);
    // wait socket
    isREADY = false;
    loading();
    wsSvc();
};
/*--------------------------------------------------------------------------------*/
const wsSvc = () => {
    WSSVC = new WebSocket(cfg.hwl.HOST);
    WSSVC.onopen = () => {
        hwinfo();
        T_hwinfo = setInterval(hwinfo, 1000 * 10);
    };
    WSSVC.onclose = () => {
        clearInterval(T_hwinfo);
        setTimeout(wsSvc, 1000 * 10);
    };
    WSSVC.onmessage = (e) => {
        const resp = JSON.parse(e.data);
        const head = resp.head ? resp.head : '';
        const data = resp.data ? resp.data : '';
        if (head == 'CSUUID') {
            if (!isREADY) {
                isREADY = true;
                ready();
            }
        }
        if (head == 'HWINFO') setHwInfo(data);
    };
    let T_hwinfo: NodeJS.Timeout;
    const hwinfo = () => WSSVC.send('{"head": "HWINFO"}');
};
/*--------------------------------------------------------------------------------*/
const setHwInfo = (data: HwInfo) => {
    if (!app) return;
    // svcinfo
    const svc = data.svc;
    app.querySelector<HTMLElement>('#hwlink')!.innerText = `: ${svc.hwlink}`;
    app.querySelector<HTMLElement>('#autoup')!.innerText = `: ${svc.autoup}`;
    app.querySelector<HTMLElement>('#csuuid')!.innerText = `: ${data.csuuid}`;
    // hwinfo
    const cpu = data.cpu;
    const mem = data.mem;
    const hwinfo = app.querySelector<HTMLElement>('#hwinfo')!;
    const uptime = Number(data.uptime);
    const hh = Math.floor(uptime / 3600);
    const mm = Math.floor((uptime % 3600) / 60);
    const memUsed = (Number(mem.used) / 1024 / 1024 / 1024).toFixed(1);
    const memTotal = (Number(mem.total) / 1024 / 1024 / 1024).toFixed(1);
    const mem_text = `${memUsed}/${memTotal} GB (${mem.percent}%)`;
    hwinfo.querySelector<HTMLElement>('#host')!.innerText = `: ${data.hostname}`;
    hwinfo.querySelector<HTMLElement>('#os')!.innerText = `: ${data.platform}`;
    hwinfo.querySelector<HTMLElement>('#cpu')!.innerText = `: ${cpu.model}`;
    app.querySelector<HTMLElement>('#mem')!.innerText = `: ${mem_text}`;
    app.querySelector<HTMLElement>('#uptime')!.innerText = `: ${hh} h ${mm} m`;
};
/*--------------------------------------------------------------------------------*/
type HwInfo = {
    csuuid: string;
    hostname: string;
    platform: string;
    uptime: number;
    svc: {
        hwlink: string;
        autoup: string;
    };
    cpu: {
        model: string;
        percent: number;
    };
    mem: {
        total: number;
        used: number;
        percent: number;
    };
};